/**
 * Canonical institutional logo paths under `apps/web/public/brand/partners/`.
 * See `docs/sdd/10-brand-assets.md` (BRAND-001..006) for the placement and
 * usage contract these paths must satisfy.
 */
export const partnerBrandAssets = {
  napai: {
    svg: '/brand/partners/napai/logo.svg',
    png1x: '/brand/partners/napai/logo@1x.png',
    png2x: '/brand/partners/napai/logo@2x.png',
    png4x: '/brand/partners/napai/logo@4x.png',
  },
  'moe-ite': {
    svg: '/brand/partners/moe-ite/logo.svg',
    png1x: '/brand/partners/moe-ite/logo@1x.png',
    png2x: '/brand/partners/moe-ite/logo@2x.png',
    png4x: '/brand/partners/moe-ite/logo@4x.png',
  },
  ncu: {
    svg: '/brand/partners/ncu/logo.svg',
    png1x: '/brand/partners/ncu/logo@1x.png',
    png2x: '/brand/partners/ncu/logo@2x.png',
    png4x: '/brand/partners/ncu/logo@4x.png',
  },
  ntpu: {
    svg: '/brand/partners/ntpu/logo.svg',
    png1x: '/brand/partners/ntpu/logo@1x.png',
    png2x: '/brand/partners/ntpu/logo@2x.png',
    png4x: '/brand/partners/ntpu/logo@4x.png',
  },
  nthu: {
    svg: '/brand/partners/nthu/logo.svg',
    png1x: '/brand/partners/nthu/logo@1x.png',
    png2x: '/brand/partners/nthu/logo@2x.png',
    png4x: '/brand/partners/nthu/logo@4x.png',
  },
  ai4x: {
    svg: '/brand/partners/ai4x/logo.svg',
    png1x: '/brand/partners/ai4x/logo@1x.png',
    png2x: '/brand/partners/ai4x/logo@2x.png',
    png4x: '/brand/partners/ai4x/logo@4x.png',
  },
} as const

export type PartnerBrandKey = keyof typeof partnerBrandAssets
